export const toggleConfig =()=> {
  function fetchToggles(requestURL){
    const xhr = new XMLHttpRequest();
    xhr.open("GET", requestURL, false);
    xhr.send();
    return JSON.parse(xhr.response);
  }

  const featureTogglesConfig = fetchToggles('/clapply/cl/toggles');
  Object.freeze(featureTogglesConfig);

  function isOn(toggle) {
    if (typeof featureTogglesConfig[toggle] === 'undefined') {
      return false;
    }
    return featureTogglesConfig[toggle] === true;
  }

  function get(toggle) {
    if (typeof featureTogglesConfig[toggle] === 'undefined') {
      return false;
    }
    return featureTogglesConfig[toggle];
  }

  function isOff(toggle) {
    if (typeof featureTogglesConfig[toggle] === 'undefined') {
      return true;
    }
    return featureTogglesConfig[toggle] === false;
  }

  return {
    "get": get,
    "isOn": isOn,
    "isOff": isOff
  };
};
